<template>
    <div class="EvieChatEmptyConversation">
        <div class="EvieChatEmptyConversation__center">
            <div class="EvieChatEmptyConversation__iconWrapper">
                <EidIcon class="EvieChatEmptyConversation__icon" :icon-src="faSparkles" />
            </div>
            <h2 class="EvieChatEmptyConversation__heading">
                What can I help you with?
            </h2>
            <PromptInput
                ref="promptInput"
                class="EvieChatEmptyConversation__input"
                :value="inputDraft"
                :is-loading="false"
                :animate-placeholder="true"
                @send="$emit('send', $event)"
                @input="$emit('draft-change', $event)"
            />
            <div class="EvieChatEmptyConversation__prompts">
                <EvieChatLandingPrompt
                    v-for="item in starterPrompts"
                    :key="item.text"
                    :prompt="item.text"
                    :icon="item.icon"
                    :icon-color="item.iconColor"
                    :icon-bg="item.iconBg"
                    @click="$emit('send', item.text)"
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.EvieChatEmptyConversation {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    overflow-y: auto;

    &__center {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        width: 100%;
        max-width: 720px;
        padding: 40px 16px;
    }

    &__iconWrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 64px;
        border-radius: 16px;
        background: linear-gradient(var(--eidSafetyBlue), var(--eidTrustGreen));
        color: var(--eidWhite);
        font-size: 28px;
    }

    &__icon {
        font-size: 28px;
    }

    &__heading {
        font-family: var(--evie-font-stack);
        font-size: 28px;
        font-weight: 700;
        margin: 0;
        text-align: center;
        color: var(--eidQualityBlack);
    }

    &__input {
        width: 100%;
    }

    &__prompts {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { faSparkles } from '@fortawesome/pro-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    import { STARTER_PROMPTS } from '@/modules/evie-ai/utils/starterPrompts';

    import EvieChatLandingPrompt from '../EvieChatLanding/sub-components/EvieChatLandingPrompt.vue';
    import PromptInput from '../PromptInput/PromptInput.vue';

    export default defineComponent({
        name: 'EvieChatEmptyConversation',
        components: { EidIcon, PromptInput, EvieChatLandingPrompt },
        props: {
            inputDraft: { type: String, default: '' },
        },
        emits: [ 'draft-change', 'send' ],
        data() {
            return {
                faSparkles,
                starterPrompts: STARTER_PROMPTS,
            };
        },
        mounted() {
            this.$nextTick(() => (this.$refs.promptInput as any)?.focus?.());
        },
    });
</script>
